// extracted by mini-css-extract-plugin
export default {"miPerfil":"RegisteredUserProfile_miPerfil__2Q+34","commentsAndSuscription":"RegisteredUserProfile_commentsAndSuscription__IxKqA"};